export default {"src":"/_next/static/media/user.77fe70da.svg","height":16,"width":16};